export enum AllianzCoverStatus {
    Pending = 'Pending',
    NoCover = 'NoCover',
    Partial = 'Partial',
    Cover = 'Cover',
    Rejected = 'Rejected',
    Closed = 'Closed',
    CheckPolicy = 'CheckPolicy',
    Inactive = 'Inactive',
    Failed = 'Failed',
}
